import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/amit-logo.jpeg`} alt="" />
      </Link>
      <header>
        <h2>Amit Khajuria</h2>
        <p><a href={`${PUBLIC_URL}/images/Resume.pdf`} download>Download Resume</a></p>
        <p><a href="mailto:amitkhajuriaworks@gmail.com">Amitkhajuriaworks@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Amit, an experienced full stack developer.
        I have a strong background in app development,
        with years of hands-on experience in creating innovative solutions.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Amit Khajuria</p>
    </section>
  </section>
);

export default SideBar;
